import http, { unwrap } from './http'

export const authApi = {
  register: payload => http.post('/video/portal/member/register', payload).then(unwrap),
  login: (username, password) => http.post('/video/portal/member/login', { username, password }).then(unwrap),
  info: () => http.get('/admin/info').then(unwrap),
  logout: () => http.post('/admin/logout').then(unwrap)
}



// WEBPACK FOOTER //
// ./src/api/auth.js